import { render, staticRenderFns } from "./company-import.vue?vue&type=template&id=6bbcacd0&scoped=true&"
import script from "./company-import.vue?vue&type=script&lang=js&"
export * from "./company-import.vue?vue&type=script&lang=js&"
import style0 from "./company-import.vue?vue&type=style&index=0&id=6bbcacd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbcacd0",
  null
  
)

export default component.exports